import script from "./AdiWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AdiWidget.vue?vue&type=script&setup=true&lang=js"

import "./AdiWidget.vue?vue&type=style&index=0&id=3f29b9b4&scoped=true&lang=css"
import "./AdiWidget.vue?vue&type=style&index=1&id=3f29b9b4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f29b9b4"]])

export default __exports__